export default {
  quickMoveIns: [],
  filters: {
    minPrice: false,
    maxPrice: false,
    baths: false,
    beds: false,
    neighborhoods: [],
  },
};
